export default async function getGoogleInfo({
  accessToken
}) {
  try {
    const response = await fetch('/api/auth/getGoogleInfo', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        googleToken: accessToken
      })
    });
    const data = await response.json();
    return data;
  } catch (e) {
    console.error('[getGoogleInfo]', e);
    return null;
  }
}